import { IFilterProps } from '@legacy/reducers/FilterReducer/FilterReducer';
import { concatQueries } from '@legacy/utils/url';

interface IParams {
  [key: string]: string;
}

export const filterURLParams = (
  selectedFilterList: Record<string, IFilterProps>,
  params?: IParams,
) => {
  // Return {} if params is empty
  let filteredParams = {};
  if (params) {
    filteredParams = Object.entries(params).reduce<IParams>(
      (acc, [key, value]) => {
        if (value !== '') {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
  }

  const items = Object.keys(selectedFilterList);
  let filteredList = concatQueries(
    items
      .filter(
        (item) =>
          selectedFilterList[item].values
            .map((value) => value.value)
            .toString() !== '',
      )
      .flatMap((item) => [
        {
          param: `${item}Ids`,
          value: selectedFilterList[item].values
            .map((value) => value.value)
            .toString(),
          isAppended: true,
        },
        {
          param: `Is${item}Inclusive`,
          value: String(selectedFilterList[item].isInclude),
          isAppended: true,
        },
      ]),
  );

  // Check if params is an empty object and replace the first '&' with '?'
  if (Object.keys(filteredParams).length === 0) {
    filteredList = filteredList.replace(/^&/, '?');
  }

  return { filteredList, filteredParams };
};
